// extracted by mini-css-extract-plugin
export default {"modal-title":"eDdh2","modalTitle":"eDdh2","modal-header":"rOw3z","modalHeader":"rOw3z","modal-body":"DVjxf","modalBody":"DVjxf"};